import axios from 'axios'

export function getFuncTree() {
    return axios({
        url: '/user/sysGroup/tree',
        method: 'get',
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

// 获取部门停车费列表
export function getParkingBalanceList(data) {
    return axios({
        url: '/user/SysOrganizationWsg/listTop',
        method: 'get',
        params: data,
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

// 编辑部门停车费余额
export function setParkingBalance(data) {
    return axios({
        url: '/user/SysOrganizationWsg/setParkingBalance',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

export function getUser(data) {
    return axios({
        url: '/user/SysUserWsg/allUser',
        method: 'get',
        params: data,
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

export function addUser(data) {
    return axios({
        url: '/user/SysUserWsg',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

export function editUser(data) {
    return axios({
        method: 'put',
        url: '/user/SysUserWsg',
        data: data,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

export function deleteUser(data) {
    return axios({
        url: "/user/SysUserWsg/" + data,
        method: "delete",
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

export function resetPwd(userId) {
    return axios({
        method: 'post',
        url: '/user/SysUserWsg/resetPwd',
        params: {
            userId:userId
        },
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

export function selectRole() {
    return axios({
        url: '/user/SysUserWsg/getRoleList',
        method: 'get',
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}
